<template>
  <div>
    <!-- Banner y título -->
    <div class="Linea1"></div>
    <div class="Linea2"></div>
   
    <div class="header-Icono">
      <router-link to="/InicioSesion" class="logo">
  <i class="bi bi-person-circle"></i>
</router-link>
</div>

            <!-- Título principal -->
    <div class="container mt-5" id="mi_aplicacion">
      <h2 class="text-center">¡Reserva tu Traslado!</h2>

      <!-- Carrusel -->
      <div class="mb-3">
        <div class="custom-form">
          <div
            id="carouselExample"
            class="carousel slide"
            data-bs-ride="carousel"
            data-bs-interval="3000"
          >
            <div class="carousel-inner">
              <!-- Primer slide -->
              <div class="carousel-item active">
                <img src="@/assets/Aeropuerto AAC.jpg" class="d-block w-100" alt="Aeropuerto">
                <div class="carousel-caption d-none d-md-block">
                
                   <!-- Formulario -->
      <form @submit.prevent="buscarTraslado" class="bg-light p-4 rounded">
        <div class="d-flex justify-content-center flex-wrap gap-3">
          <!-- Origen -->
          <div class="input-group flex-column align-items-center">
            <label for="origen" class="form-label text-center">Origen</label>
            <div class="input-group">
              <span class="input-group-text">
                <i class="bi bi-geo-alt-fill"></i>
              </span>
              <select v-model="origen" class="form-select" id="origen" required>
                <option v-for="ubicacion in ubicaciones" :key="ubicacion.Id_ubicacion" :value="ubicacion.Id_ubicacion">
                  {{ ubicacion.Nombre }}
                </option>
              </select>
            </div>
          </div>
          <!-- Destino -->
          <div class="input-group flex-column align-items-center">
            <label for="destino" class="form-label text-center">Destino</label>
            <div class="input-group">
              <span class="input-group-text">
                <i class="bi bi-geo-alt-fill"></i>
              </span>
              <select v-model="destino" class="form-select" id="destino" required>
                <option v-for="ubicacion in ubicaciones" :key="ubicacion.Id_ubicacion" :value="ubicacion.Id_ubicacion">
                  {{ ubicacion.Nombre }}
                </option>
              </select>
            </div>
          </div>
        </div>
  <!-- Botón de búsqueda -->
  <div class="text-center mt-3">
    <button type="submit" class="btn btn-primary">
      BUSCAR TRASLADO
    </button>
  </div>
</form>
                </div>
              </div>
<!-- Segundo slide -->
<div class="carousel-item position-relative">
  <!-- Imagen principal del slide -->
  <img src="@/assets/TG.jpg" class="d-block w-100" alt="Tuxtla Gutiérrez">
  <div class="carousel-caption d-none d-md-block">

  
    
      <form @submit.prevent="buscarTraslado">
        <div class="d-flex justify-content-center flex-wrap gap-3">
          <!-- Origen -->
          <div class="input-group flex-column align-items-center">
            <label for="origen" class="form-label text-center">Origen</label>
            <div class="input-group">
              <span class="input-group-text">
                <i class="bi bi-geo-alt-fill"></i>
              </span>
              <select v-model="origen" class="form-select" id="origen" required>
                <option v-for="ubicacion in ubicaciones" :key="ubicacion.Id_ubicacion" :value="ubicacion.Id_ubicacion">
                  {{ ubicacion.Nombre }}
                </option>
              </select>
            </div>
          </div>
          <!-- Destino -->
          <div class="input-group flex-column align-items-center">
            <label for="destino" class="form-label text-center">Destino</label>
            <div class="input-group">
              <span class="input-group-text">
                <i class="bi bi-geo-alt-fill"></i>
              </span>
              <select v-model="destino" class="form-select" id="destino" required>
                <option v-for="ubicacion in ubicaciones" :key="ubicacion.Id_ubicacion" :value="ubicacion.Id_ubicacion">
                  {{ ubicacion.Nombre }}
                </option>
              </select>
            </div>
          </div>
        </div>
     
      <!-- Botón de búsqueda -->
  <div class="text-center mt-3">
    <button type="submit" class="btn btn-primary">
      BUSCAR TRASLADO
    </button>
  </div>
      </form>
    </div>
 
            </div>

              <!-- Tercer slide -->
              <div class="carousel-item">
                <img src="@/assets/SCdlC.jpg" class="d-block w-100" alt="San Cristóbal">
                <div class="carousel-caption d-none d-md-block">
                  <!-- Formulario -->
      <form @submit.prevent="buscarTraslado" class="bg-light p-4 rounded">
        <div class="d-flex justify-content-center flex-wrap gap-3">
          <!-- Origen -->
          <div class="input-group flex-column align-items-center">
            <label for="origen" class="form-label text-center">Origen</label>
            <div class="input-group">
              <span class="input-group-text">
                <i class="bi bi-geo-alt-fill"></i>
              </span>
              <select v-model="origen" class="form-select" id="origen" required>
                <option v-for="ubicacion in ubicaciones" :key="ubicacion.Id_ubicacion" :value="ubicacion.Id_ubicacion">
                  {{ ubicacion.Nombre }}
                </option>
              </select>
            </div>
          </div>
          <!-- Destino -->
          <div class="input-group flex-column align-items-center">
            <label for="destino" class="form-label text-center">Destino</label>
            <div class="input-group">
              <span class="input-group-text">
                <i class="bi bi-geo-alt-fill"></i>
              </span>
              <select v-model="destino" class="form-select" id="destino" required>
                <option v-for="ubicacion in ubicaciones" :key="ubicacion.Id_ubicacion" :value="ubicacion.Id_ubicacion">
                  {{ ubicacion.Nombre }}
                </option>
              </select>
            </div>
          </div>
        </div>
  <!-- Botón de búsqueda -->
  <div class="text-center mt-3">
    <button type="submit" class="btn btn-primary">
      BUSCAR TRASLADO
    </button>
  </div>
</form>
                </div>
              </div>


            <!-- Pie de página con texto y enlace -->
<div class="position-absolute bottom-0 start-0 w-100 d-flex justify-content-center align-items-center" style="background-color: #28a745; height: 40px;">
  <h6 class="text-light text-center mb-0" style="font-size: 16px;">
    Visítanos en nuestra página oficial: 
    <a href="https://chiapasincentives.com/" target="_blank" class="text-warning">ChiapasIncentives.com</a>
  </h6>
</div>
</div>
         

            <!-- Botones de navegación del carrusel -->
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExample"
              data-bs-slide="prev"
            >
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Previous</span>
            </button>
            <button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExample"
              data-bs-slide="next"
            >
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  
</template>


<script>
import Swal from "sweetalert2";


export default {
  name: "ClienteDashboard",
  data() {
    return {
      ubicaciones: [], // Almacena las ubicaciones traídas desde el backend
      origen: null, // Id de la ubicación seleccionada como origen
      destino: null, // Id de la ubicación seleccionada como destino
    };
  },
  methods: {
  async cargarUbicaciones() {
    try {
      // Llama al backend para obtener ubicaciones
      const response = await fetch(this.$backendUrl + "obtenerUbicaciones.php");
      const data = await response.json();

      if (data.success) {
        this.ubicaciones = data.ubicaciones; // Rellena las ubicaciones desde el backend
      } else {
        alert("Error al cargar ubicaciones: " + data.message); // Usando alert en lugar de SweetAlert
      }
    } catch (error) {
      alert("Error en la solicitud al backend: " + error.message); // Usando alert en lugar de SweetAlert
    }
  },

    buscarTraslado() {
    if (this.origen === this.destino) {
      Swal.fire({
        icon: "warning",
        title: "Advertencia",
        text: "El origen y el destino no pueden ser iguales.",
        confirmButtonText: "Aceptar",
      });
      return;
    }


      // Redirigir con Vue Router pasando los IDs de las ubicaciones seleccionadas
      this.$router.push({
        name: "TrasladosDisponibles",
        query: {
          origen: this.origen,
          destino: this.destino,
        },
      });
    },
  },
  mounted() {
    // Llama al método para cargar las ubicaciones al montar el componente
    this.cargarUbicaciones();
  },
};
</script>

  
<style scoped>

.Linea1 {
    height: 30px !important;
    background-color: rgb(151, 195, 53);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .Linea2 {
    height: 30px;
    background-color: rgba(41, 179, 156, 0.963);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .header-Icono {
  position: relative;
  width: 100%;
  height: 3px; 
  background-color: #f8f9fa; 
}

.logo {
  position: absolute;
  top:5px; 
  right: 30px; 
  font-size: 30px; 
  color: #000; 
  text-decoration: none; 
}

.logo:hover {
  color: rgba(41, 179, 156, 0.963); 
  transition: color 0.3s ease; 
}

  
  h2 {
    background-color: #f52349;
    color: white;
    text-align: center;
    font-weight: bold;
    font-size: 16px;
    padding: 10px ;
    margin-bottom: 10px 30px;
    text-transform: uppercase;
    margin-top: -25px;
    width: 110%;
  }

  .container {
  max-width: 620px;
  margin: auto;
  }
  
  .custom-form {
  min-height: 73vh;
  background-color: #2eb3a0;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0px auto 0px -50px; 
  padding: 15px;
  box-shadow: 0 3px 3px rgba(0, 0, 0, 0.705);
  border-radius: 10px;
  width: 130%;
  max-width: 2000px;
}

/* Ajustar las imágenes del carrusel */
.carousel-item img {
  width: 100%; 
  height: auto;
  object-fit: cover;
  border-radius: 5px;
}

/* Botones del carrusel */
.carousel-control-prev,
.carousel-control-next {
  width: 20px; 
  height: 20px; 
  background-color: rgba(0, 0, 0, 0.279); 
  border-radius: 50%; 
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute; 
  top: 100%; 
  transform: translateY(-50%); 
}

/* Íconos dentro de los botones */
.carousel-control-prev-icon,
.carousel-control-next-icon {
  width: 10px; 
  height: 10px; 
  background-size: 100%; 
}



/* Ajustes generales para el formulario */
form {
  display: flex; 
  flex-wrap: wrap; 
  justify-content: center; 
  align-items: center;
  width: 100%;
  max-width:1000px; 
  margin: 10px auto 160px ; 
  background-color: transparent !important; 
  padding: 0px; 

}

/* Ajustes generales para las etiquetas */
.form-label {
  font-size: 16px; 
  font-weight: bold; 
  margin-bottom: 0px; 
  color: #ffffff; 
  -webkit-text-stroke: 1px #000000; 
  text-transform: uppercase; 
  text-align: center;
  width: 100%; 
}


/* Ajustes para los grupos de entrada */
.input-group {
  display: flex; 
  align-items: flex-start; 
  width: 20%; 
  margin-bottom: 20px; 
  min-width: 200px; 
}

/* Iconos y textos dentro de los campos */
.input-group-text {
  background-color: #2eb3a0; 
  color: #090909; 
  font-size: 12px; 
  padding: 8px; 
  border-radius: 5px 0 0 5px; 
  height: 30px; 
  display: flex;
  align-items: center;
}

/* Campos de entrada */
.input-group input,
.input-group select {
  font-size: 12px; 
  height: 30px; 
  padding: 5px; 
  border-radius: 0 5px 5px 0; 
  flex: 1; 
  border: 1px solid #ccc; 
}




/* Botón de búsqueda */
.btn-primary {
  background-color: #16ab9c;
  border: none;
  font-size: 12px; 
  font-family: Impact;
  padding: 5px 20px ; 
  border-radius: 5px; 
  margin: -10px  ; 
  display: block; 
  position: relative; 
  top: -30px; 
}

.btn-volver:hover {
  background-color: #218838;
}

 </style>